import { VStack, Heading, Box } from '@chakra-ui/react';
import React from 'react';

export const AdminPageTab = (props: {
  title: string;
  description: React.ReactNode;
  children: React.ReactNode;
}) => {
  return (
    <VStack align='start' mt='4' spacing="2">
      <Heading size="xs">{props.title}</Heading>
      <Box color='fg.muted' mb='8'>{props.description}</Box>
      {props.children}
    </VStack>
  );
}